import {WithSummaryModel} from "../../../../../../../common/entity/dto/plain/withSummary.model";
import {TreatmentJourneyDefinitionSummaryModel} from "./treatmentJourneyDefinitionSummary.model";
import {
    TreatmentJourneyStepDefinitionModel
} from "../../../step/api/entity/treatmentJourneyStepDefinition.model";

export class TreatmentJourneyDefinitionModel extends WithSummaryModel<TreatmentJourneyDefinitionSummaryModel> {
    stepDefinitions: TreatmentJourneyStepDefinitionModel[] = [];
}